<template>
  <el-date-picker
    v-model="innerVM"
    :type="type"
    :value-format="valueFormat"
    unlink-panels
    :disabled-date="disabledDate"
    @calendar-change="calendarChange"
    v-bind="attrs"
  />
</template>

<script setup>
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

/*
 * 增强版daterange选择器，直接对应两个起始字段
 * v-model:end-field="formData.endTime"
 * v-model:start-field="formData.startTime"
 */
const attrs = useAttrs();
const props = defineProps({
  startField: {
    type: String,
    default: '',
  },
  endField: {
    type: String,
    default: '',
  },
  valueFormat: {
    type: String,
    default: 'YYYY-MM-DD',
  },
  appendSuffix: {
    // 是否追加起止时间后缀，开始时间追加00:00:00，结束时间追加23:59:59
    type: Boolean,
    default: false,
  },
  showDisableDate: {
    //是否展示不可选日期
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    validator: (val) => ['datetimerange', 'daterange', 'monthrange', 'yearrange'].includes(val),
    default: 'daterange',
  },
  limitDate: {
    type: Number,
  },
  limitType: {
    type: String,
    validator: (val) => ['year', 'month', 'day'].includes(val),
    default: 'day',
  },
  // errMsg: {
  //   //错误提示
  //   type: String,
  // },
  disabledDate: {
    type: Function,
  },
});

const emit = defineEmits(['update:startField', 'update:endField', 'calendar-change']);
dayjs.extend(duration);
const { proxy } = getCurrentInstance();
const innerVM = computed({
  get: () => (props.startField && props.endField ? [props.startField, props.endField] : []),
  set: (val) => {
    if (val?.length > 0) {
      // if (props.limitDate && dayjs.duration(dayjs(val[1]).endOf('day').diff(dayjs(val[0]).startOf('day'))).as('day') > props.limitDate) {
      //   if (props.errMsg) {
      //     proxy.$modal.msgWarning(`${props.errMsg}`);
      //   } else {
      //     proxy.$modal.msgWarning(`选择日期间隔不能大于${props.limitDate}天，请重新选择`);
      //   }
      //   emit('update:startField', null);
      //   emit('update:endField', null);
      // } else {}
      if (props.valueFormat === 'YYYY-MM-DD') {
        emit('update:startField', props.appendSuffix ? `${val[0]} 00:00:00` : val[0]);
        emit('update:endField', props.appendSuffix ? `${val[1]} 23:59:59` : val[1]);
      } else if (props.valueFormat === 'YYYY-MM-DD HH:mm:ss') {
        emit('update:startField', props.type == 'daterange' ? dayjs(val[0]).startOf('day').format(props.valueFormat) : val[0]);
        emit('update:endField', props.type == 'daterange' ? dayjs(val[1]).endOf('day').format(props.valueFormat) : val[1]);
      } else {
        emit('update:startField', dayjs(val[0]).format(props.valueFormat));
        emit('update:endField', dayjs(val[1]).format(props.valueFormat));
      }
    } else {
      // 支持清空
      emit('update:startField', null);
      emit('update:endField', null);
    }
  },
});

let calendarDate = [];
const calendarChange = (e) => {
  emit('calendar-change', e);
  calendarDate = e;
  if (e.every((item) => !!item)) {
    calendarDate = [];
  }
};

const disabledDate = (date) => {
  if (typeof props.disabledDate === 'function') {
    return props.disabledDate(date);
  }
  const [start] = calendarDate;
  if (!start) {
    return props.showDisableDate && dayjs(date).isAfter(dayjs().format(props.valueFormat))
  }
  return (
    Math.abs(dayjs(start).diff(dayjs(date), props.limitType, true)) >= props.limitDate ||
    (props.showDisableDate && dayjs(date).isAfter(dayjs().format(props.valueFormat)))
  );
};
</script>

<style scoped></style>
